import pick from 'lodash/pick';
import { stringify } from 'query-string';
import { getErrorFromResponse } from '@atlassian/jira-common-directory-v2/src/rest/errors.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';
import type { PageRequest } from '@atlassian/jira-shared-types/src/rest/jira/page.tsx';
import type { Filter } from '../../../model/index.tsx';
import type { Response } from './types.tsx';

export const createEndpointPath = () => '/rest/agile/1.0/board';

export const createSearchQuery = (
	filter: Filter,
): {
	name?: string | undefined;
	searchQuery?: string;
	searchBy?: string;
} => ({
	name: filter.text || undefined,
});

const createProjectFilter = (
	filter: Filter,
): {
	projectLocation: string | undefined;
} => ({
	projectLocation: filter.project ? filter.project.value : undefined,
});

const createUserFilter = (
	filter: Filter,
): {
	accountIdLocation: string | undefined;
} => ({
	accountIdLocation: filter.user ? filter.user.accountId : undefined,
});

export const createUrl = (request: PageRequest, filter: Filter, includePrivate: boolean) => {
	const queryParams = {
		...pick(request, 'startAt', 'maxResults', 'orderBy', 'expand'),
		...(filter.text ? createSearchQuery(filter) : undefined),
		...(filter.project ? createProjectFilter(filter) : undefined),
		...(filter.user ? createUserFilter(filter) : undefined),
		includePrivate,
		overrideFilterPermissions: true,
	};

	return `${createEndpointPath()}?${stringify(queryParams)}`;
};

const getDashboards = async (
	request: PageRequest,
	filter: Filter,
	includePrivate: boolean,
): Promise<Response> => {
	const url = createUrl(request, filter, includePrivate);
	const response = await fetch(url, getDefaultOptions(url));

	if (response.ok) {
		return response.json();
	}

	throw await getErrorFromResponse(response, 'Cannot fetch boards');
};

export default getDashboards;
